import React from "react";
import { Switch, Route } from "react-router-dom";

import NotFound from '../NotFound';
import Dashboard from './Dashboard';
import Sectionclasselesson from "./sectionclasselessons/Sectionclasselesson";
import Schedule from "./schedules/Schedule";
import Evaluation from "./evaluations/Evaluation";
import Examen from "./examens/Evaluation";
import Draft from "./drafts/Evaluation";
import Reportcard from "./reportcards/Reportcard";
import Studentreportcard from "./reportcards/Studentreportcard";
import Question from "./questions/Question";
import Note from "./notes/Note";
import Login from "../../partials/Login";
import Report from "./reports/Report";
import Archive from "./archives/Archive";
import Profile from "../users/Profile";
import Search from "../users/Search";
import ArchiveDetail from "./archives/ArchiveDetail";
import Reportcardfile from "./reportcards/Reportcardfile";
import Reportcardfail from "./reportcards/Reportcardfail";
import Discipline from "./disciplines/Discipline";
import Presence from "./presences/Presence";
import Sms from "./sms/Sms";
import ScheduleProposition from "./schedules/ScheduleProposition";
 

function handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
}

function RouterPage(){
    return(
        <Switch>
            {
                handleCheck("Afficher pedagogie") == true && (
                    <Route exact path="/" component={Dashboard} />
                )
            }
            {
                handleCheck("Afficher cours") == true && (
                    <Route  path="/sectionclasselessons" component={Sectionclasselesson} />
                )
            }
            {
                handleCheck("Afficher horaire") == true && (
                    <Route  path="/schedules" component={Schedule} />
                )
            }
            {
                handleCheck("Afficher horaire") == true && (
                    <Route  path="/propositions" component={ScheduleProposition} />
                )
            }
            {
                handleCheck("Afficher bulletin") == true && (
                    <Route  path="/students/:student" component={Studentreportcard} />
                )
            }
            {
                handleCheck("Afficher bulletin") == true && (
                    <Route  path="/reportcards" component={Reportcard} />
                )
            }

            {
                handleCheck("Afficher bulletin") == true && (
                    <Route  path="/presences" component={Presence} />
                )
            }

            {
                handleCheck("Ajouter élève") == true && (
                    <Route  path="/sms" component={Sms} />
                )
            }

            {
                handleCheck("Afficher bulletin") == true && (
                    <Route  path="/reportcardfails" component={Reportcardfail} />
                )
            }

            {
                handleCheck("Afficher evaluation") == true && (
                    <Route  path="/reportcardfiles" component={Reportcardfile} />
                )
            }

            {
                handleCheck("Afficher note") == true && (
                    <Route  path="/evaluations/:evaluation/notes" component={Note} />
                )
            }

            {
                handleCheck("Afficher discipline") == true && (
                    <Route  path="/disciplines" component={Discipline} />
                )
            }

            {
                handleCheck("Afficher note") == true && (
                    <Route  path="/evaluations/:evaluation/questions" component={Question} />
                )
            }
            {
                handleCheck("Afficher evaluation") == true && (
                    <Route  path="/evaluations" component={Evaluation} />
                )
            }
            {
                handleCheck("Afficher rapport") == true && (
                    <Route  path="/repports" component={Report} />
                )
            }
            {
                handleCheck("Afficher archive") == true && (
                    <Route  path="/archives/student/:year" component={ ArchiveDetail } />
                )
            }
            {
                handleCheck("Afficher archive") == true && (
                    <Route  path="/archives" component={Archive} />
                )
            }
            {
                handleCheck("Afficher evaluation") == true && (
                    <Route  path="/examens" component={Examen} />
                )
            }
            {
                handleCheck("Afficher evaluation") == true && (
                    <Route  path="/drafts" component={Draft} />
                )
            }
            
            <Route  path="/search/:search" component={ Search } />
            <Route  path="/get/:user_id" component={ Login } />
            <Route  path="/login" component={ Login } />
            <Route  path="/profile" component={Profile} />
            <Route component={NotFound} />
        </Switch>
    )
}

export default RouterPage;
